import React, { useState, useEffect } from 'react';
import { getFilterForUser } from './utils/utils';
import { authFetch } from './utils/api';

const CmbCustomers = ({ value, onChange, onAddNew, label = 'Customer:', customers, setCustomers, showAll = false, filterUserId = null, showUserName = false }) => {
  //const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const filter = showAll ? '' : getFilterForUser();
        const data = await authFetch(`/customers/${filter}`);
        setCustomers(data);
      } catch (error) {
        console.error('Failed to fetch customers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  const handleChange = (e) => {
    const selectedId = e.target.value;

    if (selectedId === 'add_new') {
      if (onAddNew) onAddNew();
      return;
    }

    const selectedCustomer = customers.find(c => c.id.toString() === selectedId);
    onChange(selectedCustomer);
  };

    return (
      <div className="a-container">
        <label htmlFor="cmbCustomers">{label}</label>
        {loading ? (
          <span>Loading...</span>
        ) : (
          <select
            id="cmbCustomers"
            value={value?.id || ''}
            onChange={handleChange}
            style={{
              maxWidth: '300px',
              width: '100%',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {/* disabled hidden */}
            <option value="" >Select an option</option>
            <option value="add_new">+ Add New Customer</option>
            {[...customers]
              .filter(c => !filterUserId || String(c.fkUserId) === String(filterUserId))
              .sort((a, b) => b.id - a.id) // Sort by id descending
              .map((cust) => (
                <option key={cust.id} value={cust.id}>
                  {cust.name}{showUserName && cust.user_name ? `  —  ${cust.user_name}` : ''}
                </option>
              ))}
          </select>
        )}
      </div>
    );
};

export default CmbCustomers;
